import { useQuery } from "react-query"
import { getBandCustomMailerTemplates } from "@requests/bandCustomMailerTemplates"
import { MailerType } from "@models/bands"

export function useBandCustomMailerTemplates(
  bandId: number,
  mailerType?: MailerType,
) {
  return useQuery(["band_custom_mailer_templates", bandId, mailerType], () =>
    getBandCustomMailerTemplates(bandId, mailerType),
  )
}
